import React, { useState, useEffect } from 'react';
import { testimonials } from '../data/mockData';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const TestimonialsSection = () => {
  const [idx, setIdx] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setFading(true);
      setTimeout(() => { setIdx((p) => (p + 1) % testimonials.length); setFading(false); }, 300);
    }, 7000);
    return () => clearInterval(timer);
  }, []);

  const go = (dir) => {
    if (fading) return;
    setFading(true);
    setTimeout(() => {
      setIdx((p) => (p + dir + testimonials.length) % testimonials.length);
      setFading(false);
    }, 300);
  };

  const t = testimonials[idx];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-4">
            <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">Client Stories</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-5">
              What They Say About Us
            </h2>
            <p className="text-base text-[#4B5563] leading-relaxed">
              Real feedback from businesses that trusted us with their brand protection.
            </p>
          </div>

          <div className="lg:col-span-8">
            <div
              data-testid="testimonial-card"
              className="border border-[#E5E7EB] p-10 md:p-14 bg-[#F8F9FA] transition-opacity duration-300"
              style={{ opacity: fading ? 0.3 : 1 }}
            >
              <div className="flex items-center gap-1 mb-6">
                {[...Array(t.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#002FA7] text-[#002FA7]" />
                ))}
              </div>
              <blockquote className="text-xl md:text-2xl font-bold text-[#0A0F1C] leading-relaxed tracking-tight mb-8 italic">
                &ldquo;{t.content}&rdquo;
              </blockquote>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#0A0F1C] flex items-center justify-center text-white font-bold text-lg">{t.name.charAt(0)}</div>
                <div>
                  <div className="font-bold text-[#0A0F1C]">{t.name}</div>
                  <div className="text-xs text-[#4B5563] uppercase tracking-wider">{t.role}</div>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-4 mt-8">
              <Button data-testid="testimonial-prev" onClick={() => go(-1)} disabled={fading} variant="outline" className="w-10 h-10 p-0 rounded-none border-[#E5E7EB] hover:bg-[#0A0F1C] hover:text-white hover:border-[#0A0F1C] transition-all duration-300">
                <ChevronLeft className="w-5 h-5" />
              </Button>
              <div className="flex items-center gap-2">
                {testimonials.map((_, i) => (
                  <button key={i} data-testid={`testimonial-dot-${i}`} onClick={() => { if (!fading) { setFading(true); setTimeout(() => { setIdx(i); setFading(false); }, 300); } }} className={`transition-all duration-300 ${i === idx ? 'w-8 h-1 bg-[#002FA7]' : 'w-3 h-1 bg-[#E5E7EB] hover:bg-[#4B5563]'}`} />
                ))}
              </div>
              <Button data-testid="testimonial-next" onClick={() => go(1)} disabled={fading} variant="outline" className="w-10 h-10 p-0 rounded-none border-[#E5E7EB] hover:bg-[#0A0F1C] hover:text-white hover:border-[#0A0F1C] transition-all duration-300">
                <ChevronRight className="w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
